import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import { MODALS } from '../brands/default/constants';
import ThemeContext from '../providers/ThemeProvider';

const VipLoginModal = ({
  ariaLabelledBy,
  backdrop,
  backdropClassName,
  centered,
  children,
  container,
  dialogId,
  extraClasses,
  keyboard = true, // esc will work by default
  showHeader = true,
  size,
  title,
  titleImage = null,
  titleImageAlt = null,
  showModal,
  expressCheckout,
}) => {
  const theme = useContext(ThemeContext);

  if (!showModal) return null;

  const setModalId = (dialogElement) => {
    dialogElement.setAttribute('id', dialogId);
  };

  return (
    <>
      <Modal
        aria-labelledby={ariaLabelledBy}
        backdrop={backdrop}
        backdropClassName={backdropClassName}
        centered={centered}
        className={extraClasses}
        container={container}
        keyboard={keyboard}
        onEntered={setModalId}
        show={showModal}
        size={size}
      >
        {showHeader && (
          <Modal.Header className="modal-header">
            <Modal.Title className="modal-title">
              {expressCheckout ? (
                ''
              ) : (
                <div className="modal-title-image">
                  <img alt={titleImageAlt} src={titleImage} width="81px" />
                </div>
              )}
              <div className="modal-title-text">{title}</div>
            </Modal.Title>
          </Modal.Header>
        )}
        <Modal.Body>{children}</Modal.Body>
      </Modal>
      <style global jsx>{`
        // defaults
        .modal-open {
          padding-left: 0 !important;
        }
        .modal-open .modal {
          padding-left: 0 !important;
        }
        .vip-modal {
          position: fixed;
          top: 10%;
        }
        .modal-content {
          border: none;
          border-radius: 6px;
          box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
          background-color: ${expressCheckout ? 'white' : 'black'};
        }

        .modal-header .close {
          font-size: 18px;
          padding-right: 20px;
          padding-top: 20px;
          z-index: 1000;
          color: ${expressCheckout ? 'black' : 'white'};
        }

        .modal-body .deal-main-deal__discount {
          background-color: ${theme.colors.primary};
        }
        .modal-body .vip-login {
          background-color: black;
        }

        .modal-title {
          display: flex;
        }
        .modal-title-image {
          margin-left: 20px;
          padding: 10px 0 20px 0;
          color: ${expressCheckout ? 'black' : 'white'};
          display: flex;
        }
        .modal-title-text {
          color: ${expressCheckout ? 'black' : 'white'};
          margin-top: 10px;
          margin-left: 20px;
          font-size: 22px;
        }
        @media (max-width: ${theme.breakpoints.smDown}) {
          .modal-title-text {
            color: ${expressCheckout ? 'black' : 'white'};
            margin-top: 15px;
            margin-left: 10px;
            font-size: 18px;
          }
          .modal-title-image {
            margin-left: 10px;
            padding: 10px 0 20px 0;
            color: white;
            display: flex;
          }
        }
      `}</style>
    </>
  );
};

export default VipLoginModal;

VipLoginModal.propTypes = {
  ariaLabelledBy: PropTypes.string.isRequired,
  backdrop: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  backdropClassName: PropTypes.string,
  centered: PropTypes.bool,
  children: PropTypes.node,
  container: PropTypes.object, // a DOM node
  dialogId: PropTypes.string,
  extraClasses: PropTypes.string,
  keyboard: PropTypes.bool,
  showHeader: PropTypes.bool,
  showModal: PropTypes.bool,
  size: PropTypes.string,
  title: PropTypes.string,
  titleImage: PropTypes.string,
  titleImageAlt: PropTypes.string,
};

VipLoginModal.defaultProps = {
  backdrop: true,
  backdropClassName: '',
  centered: false,
  dialogId: MODALS.default,
  extraClasses: '',
  setShowModal: () => {},
  size: '',
  title: '',
};
